const PROD = {
  AORTA_HOST: "https://auth.eka.care",
  TRYST_HOST: "https://tryst.eka.care",
  AXON_HOST: "https://axon.eka.care",
  PARCHI_HOST: "https://parchi.eka.care",
  CURIO_HOST: "https://eka.care",
  TELE_HOST: "https://mweb.eka.care",
  METROLPOLIS_HOST: "https://consultation.metropolisindia.com",
  API_EKA_HOST: "https://api.eka.care",
  AORTA_GO_HOST: "https://aortago.eka.care",
  TELE_BE_V2: "https://resono.eka.care",
  DEEPTHOUGHT_HOST: "https://deepthought.eka.care",
  RECEIPT_DOMAIN: "https://doc-receipts.eka.care",
  pagifyJS: "https://elixir-dr.eka.care/pagify/main/pagify.standalone.js",
  cdn: "https://elixir-dr.eka.care",
};

const DEV = {
  AORTA_HOST: "https://aorta.dev.eka.care",
  TRYST_HOST: "https://tryst.dev.eka.care",
  AXON_HOST: "https://axon.dev.eka.care",
  PARCHI_HOST: "https://parchi.dev.eka.care",
  CURIO_HOST: "https://curio.dev.eka.care",
  TELE_HOST: "https://mweb.dev.eka.care",
  METROLPOLIS_HOST: "https://consultation.metropolisindia.com",
  API_EKA_HOST: "https://api-stage.dev.eka.care",
  AORTA_GO_HOST: "https://aortago.dev.eka.care",
  TELE_BE_V2: "https://resono.dev.eka.care",
  DEEPTHOUGHT_HOST: "https://deepthought.dev.eka.care",
  RECEIPT_DOMAIN: "https://doc-receipt.s3.ap-south-1.amazonaws.com",
  pagifyJS: "https://elixir-dr.dev.eka.care/pagify/main/pagify.standalone.js",
  cdn: "https://elixir-dr.dev.eka.care",
};

const env = import.meta.env.VITE_APP_ENV === "PROD" ? PROD : DEV;

export const AORTA_HOST = env.AORTA_HOST;
export const TRYST_HOST = env.TRYST_HOST;
export const AXON_HOST = env.AXON_HOST;
export const PARCHI_HOST = env.PARCHI_HOST;
export const CURIO_HOST = env.CURIO_HOST;
export const TELE_HOST = env.TELE_HOST;
export const METROLPOLIS_HOST = env.METROLPOLIS_HOST;
export const API_EKA_HOST = env.API_EKA_HOST;
export const AORTA_GO_HOST = env.AORTA_GO_HOST;
export const TELE_BE_V2 = env.TELE_BE_V2;
export const DEEPTHOUGHT_HOST = env.DEEPTHOUGHT_HOST;
export const RECEIPT_DOMAIN = env.RECEIPT_DOMAIN;
export const CDN = env.cdn;

export const pagifyCdnJS = env.pagifyJS;
